import { useState } from 'react'
import Icon from './Icon'
export default function CopyButton({
  text,
  label = 'Copy instructions',
}: {
  text: string
  label?: string
}) {
  const [message, setMessage] = useState('')
  async function copy() {
    try {
      await navigator.clipboard.writeText(text)
      setMessage('Copied to clipboard')
    } catch {
      setMessage(
        'Copy unavailable. Select the text below or download the file.',
      )
    }
  }
  return (
    <div className="doc-copy">
      <button
        type="button"
        className="mds-button mds-button--secondary mds-button--sm"
        onClick={copy}
      >
        <Icon
          name={message === 'Copied to clipboard' ? 'check' : 'copy'}
          size={16}
        />
        {message === 'Copied to clipboard' ? 'Copied' : label}
      </button>
      <span role="status" className="doc-copy__status">
        {message}
      </span>
    </div>
  )
}
